/** Имя файла, если у коллекции пустое название. */
export const DEFAULT_FILE_NAME = 'Без названия';

/** Максимальная длина имени без расширения — с запасом до лимитов файловых систем. */
const MAX_LENGTH = 120;

/** Запрещены в Windows; `/` запрещён везде. */
const FORBIDDEN = /[<>:"/\\|?*]/g;

/**
 * Управляющие символы. Регулярка собирается из строки намеренно: в литерале
 * prettier разворачивает \u-последовательности в настоящие управляющие байты,
 * и в исходнике оказываются невидимые символы.
 */
// Подавление осознанное: вырезать управляющие символы из имени файла — цель, а не оплошность.
// eslint-disable-next-line no-control-regex
const CONTROL_CHARS = new RegExp('[\\u0000-\\u001f\\u007f]', 'g');

/** Края имени: пробелы, точки и подчёркивания там не нужны. */
const EDGES = /^[\s._]+|[\s._]+$/g;

/** Имена устройств DOS: файл с таким именем создать нельзя. */
const RESERVED = /^(con|prn|aux|nul|com\d|lpt\d)$/i;

/**
 * Приводит название коллекции к безопасному имени файла.
 *
 * Набор правил задан явно, а не «на усмотрение реализации»: иначе поведение
 * разъезжается, а пользователь получает файл, который не сохраняется на его системе.
 */
export function sanitizeFileName(raw: string): string {
  const cleaned = raw
    .replace(CONTROL_CHARS, '')
    .replace(FORBIDDEN, '_')
    .replace(/_{2,}/g, '_')
    .slice(0, MAX_LENGTH)
    // Тримминг краёв — строго после обрезки длины, иначе усечение может
    // оставить имя, заканчивающееся пробелом или точкой.
    .replace(EDGES, '');

  if (cleaned === '') {
    return DEFAULT_FILE_NAME;
  }

  return RESERVED.test(cleaned) ? `${cleaned}_` : cleaned;
}
